import { Size, IContentSource, Rectangle } from "../drawing";

/**
 * フォーマット内の1ページに相当
 * オブジェクトの実体はItemSet内にprivateIdをキーにして格納されている
 * このページがどのオブジェクトを含むかについては、privateIdの配列で管理している
 */
export class Section {
  constructor(
    public size: Size,
    public bodyRectangle: Rectangle,
    public layerImageSource: IContentSource,
    public layerImageRectangle: Rectangle,
    public thumbnailImageSource: IContentSource,
    public itemSetId: number,
    public itemPrivateIds: number[],
    public landscape: boolean,
    public formatSectionNumber: number,
    public formatId: number,
    public pageKey: number,
    public isPageSplittable: boolean,
    public shouldPrintOnFirstRegistered: boolean,
    public hasBeenBrowsed: boolean,
    public splitRedundantMargin: number,
  ) {}

  clone(): Section {
    return new Section(
      this.size.clone(),
      this.bodyRectangle.clone(),
      this.layerImageSource.clone(),
      this.layerImageRectangle.clone(),
      this.thumbnailImageSource.clone(),
      this.itemSetId,
      this.itemPrivateIds.concat(),
      this.landscape,
      this.formatSectionNumber,
      this.formatId,
      this.pageKey,
      this.isPageSplittable,
      this.shouldPrintOnFirstRegistered,
      this.hasBeenBrowsed,
      this.splitRedundantMargin,
    );
  }
}
